import { useSyncExternalStore } from 'react'

/**
 * Global light/dark theme mode — one setting shared by BOTH the storefront and the owner console.
 * "light" = Sunny Chick (warm cream + yolk); "dark" = Midnight Rooster (charcoal + gold).
 * Persisted in localStorage (`dukaano.mode`); a tiny external store so any component reads it via
 * useThemeMode() with no wrapping provider (both shells build their own theme from it — see theme.ts).
 */
export type ThemeMode = 'light' | 'dark'
const KEY = 'dukaano.mode'
const listeners = new Set<() => void>()

function read(): ThemeMode {
  return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'
}
let mode: ThemeMode = read()

export function setThemeMode(next: ThemeMode) {
  mode = next
  localStorage.setItem(KEY, next)
  listeners.forEach((l) => l())
}

export function toggleThemeMode() {
  setThemeMode(mode === 'dark' ? 'light' : 'dark')
}

export function useThemeMode(): ThemeMode {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l)
      return () => listeners.delete(l)
    },
    () => mode,
    () => 'light', // SSR/first paint default
  )
}
